// extracted by mini-css-extract-plugin
module.exports = {"productTile":"styles-module__productTile___2dRAY","ribbon":"styles-module__ribbon___Ny60X"};